import plingUrl from "../assets/pling.mp3";

// Eén HTMLAudioElement hergebruiken — kost ~25 KB geheugen na de eerste
// load en speelt direct af zonder netwerk-trip op volgende berichten.
let audio: HTMLAudioElement | null = null;
function getAudio(): HTMLAudioElement | null {
  if (typeof window === "undefined") return null;
  if (!audio) {
    audio = new Audio(plingUrl);
    audio.preload = "auto";
    audio.volume = 0.7;
  }
  return audio;
}

// Fallback synth-pling voor het geval het MP3-bestand niet kan afspelen
// (browser-restrictie, decoder-fout). Identiek aan de oude versie.
let ctx: AudioContext | null = null;
function getCtx(): AudioContext | null {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    ctx = new (window.AudioContext ||
      (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
  }
  return ctx;
}
function playSynth(): void {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.connect(gain);
  gain.connect(c.destination);
  osc.type = "sine";
  osc.frequency.setValueAtTime(880, c.currentTime);
  osc.frequency.exponentialRampToValueAtTime(1320, c.currentTime + 0.15);
  gain.gain.setValueAtTime(0.0001, c.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.15, c.currentTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.4);
  osc.start();
  osc.stop(c.currentTime + 0.42);
}

export function playPling(): void {
  const a = getAudio();
  if (!a) {
    playSynth();
    return;
  }
  // Bij snel achter elkaar binnenkomende berichten: rewind zodat we niet
  // wachten tot de vorige af is.
  try {
    a.currentTime = 0;
    const p = a.play();
    if (p && typeof p.catch === "function") {
      p.catch(() => playSynth());
    }
  } catch {
    playSynth();
  }
}

/**
 * Speelt de pling éénmaal stil af om de WebView2 audio-autoplay-restrictie
 * te omzeilen. Aanroepen tijdens een user-gesture (login-klik, eerste
 * muisklik) zodat browsers latere stille play() niet meer weigeren.
 */
export function primePling(): void {
  const a = getAudio();
  if (!a) return;
  const originalVol = a.volume;
  try {
    a.volume = 0;
    a.currentTime = 0;
    const p = a.play();
    const restore = () => {
      try {
        a.pause();
        a.currentTime = 0;
      } catch {
        /* */
      }
      a.volume = originalVol;
    };
    if (p && typeof p.then === "function") {
      p.then(restore).catch(restore);
    } else {
      restore();
    }
  } catch {
    a.volume = originalVol;
  }
}
